module.exports = {
  language: 'Արմենյան',
  checkoutConfirm: {
    ordered: 'Պատվիրվել է',
    purchased: 'Գնված է'
  },
  personal: {
    purgePopupContent:
      'Ներեցեք, ձեր դիմումի տվյալները մաքրվել են անվտանգության քաղաքականության պատճառով, եթե ցանկանում եք շուտով դիմել, կարող եք կապվել մեզ հետ'
  },
  login_maximum: {
    errorContent: 'Ներեցեք, որ այսօր հասել եք մուտքի առավելագույն ժամանակին, խնդրում ենք փորձել հաջորդ օրը:'
  },
  nationalityKay: 'hy-am',
  noneSelectedText: 'Խնդրում ենք ընտրել',
  multiselect: {
    deselect: 'Սեղմեք Enter-ը ջնջելու համար',
    select: 'Սեղմեք Enter-ը ընտրելու համար',
    selected: 'Ընտրված'
  },
  enter: ' Մուտքագրեք',
  upload_failed: 'Չհաջողվեց վերբեռնել, նորից փորձեք',
  due_time: 'Ժամանակի ընթացքում',
  requirement: 'Պահանջ',
  something_went_wrong_please_retry: 'Something went wrong, please retry',
  valid_rediret_home_page_popup_content:
    "Login exception occurred. Are you trying to go to [ {country} - {center} ] homepage to log in? If yes, please click on 'Confirm'; if no, please click 'Cancel' to select again.",
  invalid_rediret_home_page_popup_content: 'Login exception occurred, please select the country and location to proceed.',
  'Temporarily not available': 'Ժամանակավորապես հասանելի չէ',
  'Coming soon': 'Շուտով'
};
